import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import { BoldedText } from 'common-src/components/elements';
import {
  getLastPatientDocumentByModuleType,
  moduleTypes,
} from 'common-src/models/PatientInteraction';

import useCustomSelector from 'src/hooks/useCustomSelector';
import { ModuleTitle } from 'src/pages/DocumentationIndex/components';

import styles from './Promis10Module.module.scss';

const Promis10Module = ({ patientId, promis10, setPromis10 }) => {
  const document = useCustomSelector((state) =>
    getLastPatientDocumentByModuleType(state, patientId, moduleTypes.MindyPRO10Assessment.id),
  );

  useEffect(() => {
    if (!document?.note) return;

    setPromis10((prev) => ({ ...prev, note: document.note.replace(/\s+$/g, '') }));
  }, [document]);

  return (
    <div className={styles.container}>
      <ModuleTitle title="PROMIS-10" />
      <div className={[styles.note, 'font-s-14'].join(' ')}>
        {document?.note ? (
          <BoldedText
            text={promis10.note ?? ''}
            regex={new RegExp(/(---(.*?)---)|(\*\*\*(.*?)\*\*\*)/, 'gi')}
            splitBy={'\n\n'}
          />
        ) : (
          <span className={styles.placeholder}>No assessment available</span>
        )}
      </div>
    </div>
  );
};

Promis10Module.propTypes = {
  patientId: PropTypes.number,
  promis10: PropTypes.object,
  setPromis10: PropTypes.func,
};

export default Promis10Module;
